import React, { useState, useEffect } from "react";
import { Heart } from "lucide-react";
import api from "@/lib/api";

const money = (n) => (Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function BenefitsSection() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api.get("/employee/benefits")
      .then((res) => { if (active) setData(res.data); })
      .catch(() => { if (active) setData(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  if (loading || !data || !data.has_benefits) return null;

  const Row = ({ label, value }) => (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", padding: "12px 0", borderTop: "1px solid rgba(243,238,231,0.12)" }}>
      <span style={{ fontSize: 14, color: "rgba(243,238,231,0.72)" }}>{label}</span>
      <span style={{ fontSize: 15, color: "#F3EEE7", fontWeight: 600 }}>${money(value)}</span>
    </div>
  );

  return (
    <div className="earnings-body" style={{ paddingTop: 12, paddingBottom: 0 }} data-testid="benefits-section">
      <div style={{ background: "linear-gradient(168deg,#231E1A,#3A2A1E)", borderRadius: 14, padding: 20, color: "#F3EEE7" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
          <Heart size={18} color="#B0905E" />
          <span style={{ fontFamily: "Cormorant, serif", fontSize: 22, color: "#F3EEE7" }}>GT invests in you</span>
        </div>
        <div style={{ fontSize: 13, color: "rgba(243,238,231,0.7)", marginBottom: 12 }}>{data.intro}</div>

        {data.health_reimbursement_total > 0 && (
          <div data-testid="benefits-health-total" style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", paddingBottom: 8 }}>
            <span style={{ fontSize: 14, color: "rgba(243,238,231,0.72)" }}>Health reimbursement, to date</span>
            <span style={{ fontFamily: "Cormorant, serif", fontSize: 24, color: "#B0905E", fontWeight: 600 }}>${money(data.health_reimbursement_total)}</span>
          </div>
        )}
        {data.hra_total > 0 && <Row label="HRA contributions" value={data.hra_total} />}
        {data.ichra_total > 0 && <Row label="ICHRA contributions" value={data.ichra_total} />}
        {data.commute_total > 0 && <Row label="Commute support" value={data.commute_total} />}

        <div style={{ fontSize: 12, color: "rgba(243,238,231,0.5)", marginTop: 12 }}>Private to you — only you and Gia can see this.</div>
      </div>
    </div>
  );
}
